import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { isEmptyObject, getJCJPIDs } from "../../../utils/common/index";
import {
  fetchShowAlertRecharge,
  hideAlertRecharge,
} from "../../../redux/actions";
import { ExportToCsv } from "export-to-csv";
import { csvMappingRechargeSales } from "../../../utils/common/csvMappings/rechargeSales";
import OthersWalletBalanceView from "../../../views/rechargeSales/others/othersWalletBalanceView";

const OthersWalletBalance = (props) => {
  const dispatch = useDispatch();

  const { headerUnit } = useSelector((state) => state.homeReducer);

  const { getRechargeWalletBalance } = useSelector(
    (state) => state.rechargeSalesReducer
  );

  let {
    url,
    csvEndPointUrl,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchRechargeWalletBalance,
    triggerFetchRechargeWalletBalanceCSV,
  } = props;

  let { level, jioPointId, partnerRT, id, retailerId } =
    getJCJPIDs(filterValue);

  const headers = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    partnerType: filterValue.selectedPartnerRoleName.toLowerCase(),
    isRedisActive: "YES",
    dispValue: headerUnit.unit,
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchRechargeWalletData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerFetchRechargeWalletBalance(obj));
    }
    if (
      getRechargeWalletBalance &&
      isEmptyObject(getRechargeWalletBalance.data)
    ) {
      fetchRechargeWalletData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchRechargeWalletBalance,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
  ]);

  function fetchRechargeWalletCsvData(e) {
    let PT = e;
    let levelW = level;
    if (partnerRT === "JC") {
      if (e === "zd") {
        PT = "PRIMARY";
        levelW = "DISTRIBUTOR";
      } else if (e === "rds") {
        PT = "SECONDARY";
        levelW = "DISTRIBUTOR";
      } else if (e === "retailer") {
        PT = "TERTIARY";
        if (filterValue.selectedJC.split("-")[1]) {
          PT = "SELLOUT";
        }
      }
    }

    if (filterValue.partnerName === "JPM") {
      PT = "";
    }
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        ...headers,
        partnerType: PT,
        level: levelW,
      },
      extraData: csvEndPointUrl,
      tab: e,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Others_walletBalance",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerFetchRechargeWalletBalanceCSV(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = csvMappingRechargeSales({
            partnerRole:
              filterValue.selectedJC === ""
                ? filterValue.selectedPartnerRoleName
                : filterValue.selectedJC === "ALL"
                ? filterValue.selectedPartnerRoleName
                : "JP",
            data: response.content,
            tileName: e.toLowerCase(),
            section: "wallet",
          });
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertRecharge());
          setTimeout(() => {
            dispatch(hideAlertRecharge());
          }, 5000);
        }
        // setDownloadCsv(false)
      })
    );
  }
  return (
    <OthersWalletBalanceView
      fetchRechargeWalletCsvData={fetchRechargeWalletCsvData}
      isCsvActive={props.isCsvActive}
      filterValue={filterValue}
      moduleName={props.moduleName}
      section={props.section}
    />
  );
};

OthersWalletBalance.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  content: PropTypes.shape({
    actualCount: PropTypes.number,
    targetCount: PropTypes.number,
    avgPerDayCount: PropTypes.number,
  }),
};

export default OthersWalletBalance;
